import {
    FETCH_SUPERVISOR_WISE_OT_REQUEST,
    FETCH_SUPERVISOR_WISE_OT_SUCCESS,
    FETCH_SUPERVISOR_WISE_OT_FAILURE,
} from "../constants/SupervisorWiseOTConstants";

const initialState = {
    loading: false,
    data: [],
    error: null,
};

const SupervisorWiseOTReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SUPERVISOR_WISE_OT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_SUPERVISOR_WISE_OT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case FETCH_SUPERVISOR_WISE_OT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default SupervisorWiseOTReducer;
